import React, { useState } from "react";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";
export default function PriorHCTA() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    countryCode: "+91",
    phone: "",
    service: "camunda-8-implementation",
    message: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <section className="relative w-full lg:py-24 md:py-16 py-10 px-6 sm:px-8 lg:px-12 font-sans overflow-hidden text-white">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6 space-y-6">
            <div>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.05 }}
                className="inline-flex items-center gap-2 px-0.5 py-1.5 backdrop-blur-md shadow-xs mb-4"
              >
                <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-700">
                  CLINICAL AUTOMATION DISCOVERY
                </span>
              </motion.div>
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-slate-950">
                Automate{" "}
                <span className="italic font-serif font-normal text-[#5dc9f0]">
                  Prior Authorization
                </span>{" "}

              </h2>
            </div>
            <p className="text-lg text-slate-600 max-w-2xl leading-relaxed">
              Get a clinical interoperability assessment and Da Vinci implementation roadmap.
              Eliminate portal fatigue, achieve CMS-0057-F compliance, and deliver sub-minute
              approvals with Camunda 8 and SMART-on-FHIR.
            </p>
            <div className="space-y-3 pt-2">
              {[
                "CMS-0057-F & Da Vinci (CRD, DTR, PAS) aligned",
                "Native Epic & Oracle Cerner FHIR integration",
                "Zero ePHI persistent storage across microservice workers",
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 text-sm font-medium text-slate-600"
                >
                  <CheckCircle2 className="w-5 h-5 text-[#000036] shrink-0" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-6">
            <div className="rounded-xl bg-[#000036] backdrop-blur-xl border border-white/15 p-7 sm:p-10 shadow-2xl">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm  text-white mb-1.5  tracking-wider">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      required
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                      className="w-full px-4 py-3 rounded-xl bg-transparent border border-white/60 text-white placeholder-slate-100 text-sm focus:outline-none focus:border-[#5dc9f0] transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-white  mb-1.5  tracking-wider">
                      Business Email *
                    </label>
                    <input
                      type="email"
                      required
                      placeholder="name@company.com"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      className="w-full px-4 py-3 rounded-xl bg-transparent border border-white/60 text-white placeholder-slate-100 text-sm focus:outline-none focus:border-[#5dc9f0] transition-colors"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm  text-white  mb-1.5  tracking-wider">
                    Phone Number *
                  </label>
                  <div className="flex gap-2">
                    <select
                      value={formData.countryCode}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          countryCode: e.target.value,
                        })
                      }
                      className="md:w-28 w-20 md:px-3 px-1.5 py-3 rounded-xl bg-[#000036] border border-white/60 text-white text-sm focus:outline-none focus:border-[#5dc9f0] transition-colors"
                    >
                      <option value="+91">🇮🇳 +91</option>
                      <option value="+1">🇺🇸 +1</option>
                      <option value="+44">🇬🇧 +44</option>
                      <option value="+61">🇦🇺 +61</option>
                      <option value="+49">🇩🇪 +49</option>
                      <option value="+971">🇦🇪 +971</option>
                      <option value="+65">🇸🇬 +65</option>
                    </select>
                    <input
                      type="tel"
                      required
                      placeholder="98765 43210"
                      value={formData.phone}
                      onChange={(e) =>
                        setFormData({ ...formData, phone: e.target.value })
                      }
                      className="flex-1 px-4 py-3 rounded-xl bg-transparent border border-white/60 text-white placeholder-slate-100 text-sm focus:outline-none focus:border-[#5dc9f0] transition-colors"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm text-white  mb-1.5  tracking-wider">
                    Required Service *
                  </label>
                  <select
                    value={formData.service}
                    onChange={(e) =>
                      setFormData({ ...formData, service: e.target.value })
                    }
                    className="w-full px-4 py-3 rounded-xl bg-[#000036] border border-white/60 text-white text-sm focus:outline-none focus:border-[#5dc9f0] transition-colors"
                  >
                    <option value="crd-dtr-pas-implementation">
                      Full Da Vinci Implementation (CRD / DTR / PAS)
                    </option>
                    <option value="cms-0057-f-compliance">
                      CMS-0057-F Mandate Readiness &amp; Audit
                    </option>
                    <option value="ehr-integration">
                      EHR Integration (Epic / Cerner / SMART-on-FHIR)
                    </option>
                    <option value="camunda-prior-auth-orchestration">
                      Camunda 8 Prior Auth Engine Setup
                    </option>
                    <option value="payer-gateway-x12">
                      Payer Gateway &amp; X12 278 / FHIR Translation
                    </option>
                    <option value="clinical-policy-dmn">
                      Clinical Policy Rules &amp; DMN Automation
                    </option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm text-white  mb-1.5  tracking-wider">
                    Project Scope / Message
                  </label>
                  <textarea
                    rows={3}
                    placeholder="Briefly describe your current architecture or process goals..."
                    value={formData.message}
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                    className="w-full px-4 py-3 rounded-xl bg-transparent border border-white/60 text-white placeholder-slate-100 text-sm focus:outline-none focus:border-[#5dc9f0] transition-colors resize-none"
                  />
                </div>
                <button
                  type="submit"
                  className="group w-auto  relative inline-flex items-center justify-center md:justify-between gap-3 md:px-5 px-3 py-2 border border-black/15 bg-white text-slate-900 font-mono text-xs font-semibold uppercase tracking-widest transition-all duration-300 hover:bg-slate-950 hover:text-white hover:shadow-lg rounded-full"
                >
                  <span>Submit</span>
                  <div className="h-7 w-7 rounded-full bg-white/10 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1 group-hover:bg-white group-hover:text-slate-950">
                    <ArrowUpRight size={15} />
                  </div>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
